import { connect } from "react-redux";
import Shifts from "./shifts";
import {
  getShiftsRequest,
  createShiftRequest,
  updateShiftRequest,
  deleteShiftRequest,
} from "../../../store/actions/shifts.actions";
import {
  shifts,
  shiftsPagination,
  error,
  loader,
  shiftsLoading,
} from "../../../store/selectors/shift.selector";

const mapDispatchToProps = {
  getShiftsRequest,
  createShiftRequest,
  updateShiftRequest,
  deleteShiftRequest,
};

const mapStateToProps = (state) => {
  const loading = loader(state);
  const pageLoading = shiftsLoading(state);
  const allShifts = shifts(state);
  const pagination = shiftsPagination(state);
  const errors = error(state);

  return { allShifts, pagination, errors, loading, pageLoading };
};

export default connect(mapStateToProps, mapDispatchToProps)(Shifts);
